import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'day8-ui';
import { imageUrl } from '../helpers/imageUrl';

class YachtCardBaseInfo extends React.PureComponent {
  render() {
    const { images, alt } = this.props;
    return (
      <div>
        <Carousel
          slides={images?.map(img =>(
            <div key={`${JSON.stringify(img)}`} className='dui-relative dui-aspect-[16/9] dui-w-full'>
              <img
                src={imageUrl(img, '//assets.theyachtweek.com')} alt={alt}
                className="dui-absolute dui-w-full dui-h-full dui-object-cover"
              />
            </div>
          ))}
        />
        <p className="dui-text-sm dui-mt-4">
          <i>
          Please note that the make and model of your yacht may differ from these images.
          </i>
        </p>
      </div>
    );
  }
}

YachtCardBaseInfo.propTypes = {
  images: PropTypes.array,
  alt: PropTypes.string,
};

export default YachtCardBaseInfo;
